export const pageBaseStatus = {
    is_loading: 'is_loading',
    is_completed: 'is_completed',
    is_saving: 'is_saving',
    is_not_initial: 'is_not_ini',
}